module.exports = __webpack_public_path__ + "img/section1Swiper2.3ef76efb.png";